// extracted by mini-css-extract-plugin
module.exports = {"lastUpdated":"_02712f2b3b--lastUpdated--MLlSF","content":"_02712f2b3b--content--lErbs"};